import React from "react";
import { AnalyticsStatsLoaderTemplate } from "themes/administration/analytics/components";

function AnalyticsStatsLoader(props) {
    return <AnalyticsStatsLoaderTemplate {...props} />;
}

export default AnalyticsStatsLoader;
